export default {
  SUPERADMIN: {
    id: 1,
    desc: 'SuperAdmin',
  },
  ADMIN: {
    id: 2,
    desc: 'Admin',
  },
  ROUTE_PLANNER: {
    id: 3,
    desc: 'พนักงานจ่ายตั๋ว',
  },
  FUEL_EXPENSE: {
    id: 4,
    desc: 'พนักงานจ่ายน้ำมัน',
  },
  CLERK: {
    id: 5,
    desc: 'พนักงานเทียบเอกสารวางบิล',
  },
  GUEST: {
    id: 6,
    desc: 'พนักงานทั่วไป',
  },
  WATCHER: {
    id: 7,
    desc: 'พนักงานบุคคล',
  },
  FUEL_FILLER: {
    id: 8,
    desc: 'ปั๊มน้ำมัน',
  },
  FUEL_EXPENSE_CHECK_BILL: {
    id: 9,
    desc: 'พนักงานจ่ายตั๋ว-ตรวจบิล',
  },
  SERVICE_ADVISOR: {
    id: 10,
    desc: 'พนักงานแจ้งซ่อม',
  },
  DRIVER: {
    id: 11,
    desc: 'พนักงานขับรถ',
  },
  CUSTOMER: {
    id: 12,
    desc: 'ผู้จ้าง',
  },
  CARGO_OFFICER: {
    id: 13,
    desc: 'เจ้าหน้าที่ชั่งน้ำหนัก',
  },
  USER: {
    id: 14,
    desc: 'ผู้ใช้',
  },
}
